/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
const statusColors = ['success', 'processing', 'error', 'default', 'warning'];
const presetColors = [
    'pink',
    'red',
    'yellow',
    'orange',
    'cyan',
    'green',
    'blue',
    'purple',
    'geekblue',
    'magenta',
    'volcano',
    'gold',
    'lime'
];
function isPresetColor(color) {
    return presetColors.indexOf(color) !== -1;
}
function isStatusColor(color) {
    return statusColors.indexOf(color) !== -1;
}

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

/**
 * Generated bundle index. Do not edit.
 */

export { isPresetColor, isStatusColor, presetColors, statusColors };

